<template>
  <div class="draw-toolbar-vertical">
    <ul>
      <li>
        <el-button
          type="text"
          size="small"
          :disabled="drawSaving"
          title="矩形"
          @click="$emit('tool-change', 'rect')">
          <svg class="paint-icon" viewBox="0 0 24 24" aria-hidden="true">
            <rect x="6" y="6" width="12" height="12" rx="2" ry="2" />
          </svg>
        </el-button>
      </li>
      <li>
        <el-button
          type="text"
          size="small"
          :disabled="drawSaving"
          title="椭圆（Shift 画圆）"
          @click="$emit('tool-change', 'ellipse')">
          <svg class="paint-icon" viewBox="0 0 24 24" aria-hidden="true">
            <ellipse cx="12" cy="12" rx="7" ry="4.5" />
          </svg>
        </el-button>
      </li>
      <li>
        <el-button
          type="text"
          size="small"
          :disabled="drawSaving"
          title="自由绘画"
          @click="$emit('tool-change', 'free')">
          <svg class="paint-icon" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M3 17.25V21h3.75L18.81 8.94l-3.75-3.75L3 17.25z" />
            <path d="M14.06 5.19l3.75 3.75" />
          </svg>
        </el-button>
      </li>
      <li>
        <el-button
          type="text"
          size="small"
          :disabled="drawSaving"
          title="文字"
          @click="$emit('tool-change', 'text')">
          <svg class="paint-icon" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M5 6h14v2h-6v12h-2V8H5z" />
          </svg>
        </el-button>
      </li>
      <li>
        <el-button
          type="text"
          size="small"
          :disabled="drawSaving"
          title="箭头"
          @click="$emit('tool-change', 'arrow')">
          <svg class="paint-icon" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M4 20L20 4" />
            <path d="M12 4h8v8" />
          </svg>
        </el-button>
      </li>

      <li>
        <el-color-picker
          v-model="localStroke"
          size="mini"
          :predefine="predefineColors"
          title="标注颜色"
          @change="onStrokeChange"/>
      </li>
      <li>
        <el-button
          type="text"
          size="small"
          :disabled="drawSaving || !drawCanUndo"
          title="撤销"
          @click="$emit('undo')">
          <svg class="paint-icon" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M9 7L4 12l5 5" />
            <path d="M4 12h12" />
          </svg>
        </el-button>
      </li>
      <li>
        <el-button
          type="text"
          size="small"
          :disabled="drawSaving || !drawCanRedo"
          title="重做"
          @click="$emit('redo')">
          <svg class="paint-icon" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M15 7l5 5-5 5" />
            <path d="M4 12h16" />
          </svg>
        </el-button>
      </li>
      <li>
        <el-button
          type="text"
          size="small"
          :disabled="drawSaving"
          title="左旋转"
          @click="$emit('rotate', -90)">
          <span class="sj-icon-rotate-left"></span>
        </el-button>
      </li>
      <li>
        <el-button
          type="text"
          size="small"
          :disabled="drawSaving"
          title="右旋转"
          @click="$emit('rotate', 90)">
          <span class="sj-icon-rotate-right"></span>
        </el-button>
      </li>
      <li>
        <el-button
          type="text"
          size="small"
          :disabled="drawSaving"
          title="取消"
          @click="$emit('cancel')">
          <svg class="paint-icon" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M18 6L6 18" />
            <path d="M6 6l12 12" />
          </svg>
        </el-button>
      </li>
      <li>
        <el-button
          type="text"
          size="small"
          :loading="drawSaving"
          title="保存"
          @click="$emit('save')">
          <svg class="paint-icon" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M20 6L9 17l-5-5" />
          </svg>
        </el-button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'DrawToolbar',
  props: {
    stroke: {
      type: String,
      default: '#409eff',
    },
    drawSaving: {
      type: Boolean,
      default: false,
    },
    drawCanUndo: {
      type: Boolean,
      default: false,
    },
    drawCanRedo: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      localStroke: this.stroke,
      predefineColors: [
        '#409eff',
        '#67c23a',
        '#e6a23c',
        '#f56c6c',
        '#909399',
      ],
    }
  },
  watch: {
    stroke (val) {
      this.localStroke = val
    },
  },
  methods: {
    onStrokeChange (val) {
      this.$emit('stroke-change', val)
    },
  },
}
</script>

<style lang="scss" scoped>
.draw-toolbar-vertical {
  box-sizing: border-box;
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  max-height: calc(100% - 24px);
  /* 极矮视口仍可滚动，但不显示难看的滚动条 */
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  z-index: 40;
  pointer-events: auto;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
  }

  ul {
    list-style: none;
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    background-color: rgba(0, 0, 0, 0.62);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 8px;
    padding: 14px 12px;
  }

  li {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  /deep/ .el-color-picker {
    display: block;
    line-height: 0;
  }

  /deep/ .el-color-picker__trigger {
    margin: 0 auto;
  }

  .paint-icon {
    width: 22px;
    height: 22px;
    vertical-align: middle;
    color: currentColor;
  }

  .paint-icon path,
  .paint-icon rect,
  .paint-icon ellipse {
    fill: none;
    stroke: currentColor;
    stroke-width: 2.2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .el-button.is-disabled .paint-icon {
    opacity: 0.35;
  }

  [class*=" sj-icon-"],
  [class^="sj-icon-"] {
    color: currentColor;
    display: inline-block;
    font-size: 22px;
    line-height: 22px;
    vertical-align: middle;
  }

  /deep/ .el-button {
    padding: 10px;
    color: rgba(255, 255, 255, 0.72);
    background-color: transparent;
  }

  /deep/ .el-button:hover {
    color: rgba(255, 255, 255, 0.9);
  }

  /deep/ .el-button.is-disabled {
    color: rgba(255, 255, 255, 0.35);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/question-review/components/AnswerFileFullScreen/src/DrawToolbar.vue